module.exports = __webpack_public_path__ + "static/media/f4.b26b0c56.jpg";